/* Calendrier de l'Avent en rupture : encart « Ne loupe pas le calendrier 2027 »
   (snippet avent-rupture-bloc). Envoie prénom + pays + mobile au Worker
   supermot-avent-2027-sms (POST /inscrire), qui pousse dans la liste Brevo 35.
   Même logique que le formulaire du teasing 2026 (fiche-avent-teasing). */
(function () {
  var sec = document.querySelector('[data-sms-2027]');
  if (!sec || sec.dataset.pret) return;
  sec.dataset.pret = '1';

  // lien direct …#sms (stories, newsletter) : encart juste sous l'en-tête, recalé après le chargement des photos
  if (/^#sms/.test(window.location.hash)) {
    var allerAuSms = function () { sec.scrollIntoView({ block: 'start' }); };
    allerAuSms();
    window.addEventListener('load', function () { allerAuSms(); setTimeout(allerAuSms, 400); });
  }

  var form = sec.querySelector('[data-sms-form]');
  var btn = sec.querySelector('[data-sms-btn]');
  var err = sec.querySelector('[data-sms-erreur]');
  var worker = (sec.getAttribute('data-worker') || '').replace(/\/$/, '');
  var messages = {
    telephone: 'Ce numéro ne ressemble pas à un mobile du pays choisi. Vérifie et réessaie.',
    prenom: 'Dis-nous ton prénom, on t’appellera comme ça dans le SMS.',
    trop: 'Trop d’inscriptions d’un coup depuis ta connexion. Réessaie dans quelques minutes.',
    robot: 'La vérification anti-robot a échoué. Recharge la page et réessaie.',
    reseau: 'Impossible de joindre le serveur. Réessaie dans un instant.'
  };
  function jetonTurnstile() {
    try { return (window.turnstile && sec.querySelector('[data-turnstile]')) ? (window.turnstile.getResponse() || '') : ''; } catch (e) { return ''; }
  }
  function montrerErreur(code) {
    err.textContent = messages[code] || messages.reseau;
    err.hidden = false;
    // un jeton Turnstile ne sert qu'une fois : on en redemande un pour le prochain essai
    try { if (window.turnstile && sec.querySelector('[data-turnstile]')) window.turnstile.reset(); } catch (e) { /* widget absent */ }
  }
  var chPrenom = form.querySelector('[data-sms-prenom]');
  var chTel = form.querySelector('[data-sms-tel]');
  var chPays = form.querySelector('[data-sms-pays]');
  var chPiege = form.querySelector('[data-sms-piege]');
  function envoyer() {
    err.hidden = true;
    var prenom = chPrenom.value.trim();
    var tel = chTel.value.trim();
    if (!prenom) { montrerErreur('prenom'); chPrenom.focus(); return; }
    if (tel.replace(/\D/g, '').length < 8) { montrerErreur('telephone'); chTel.focus(); return; }
    btn.disabled = true;
    var libelle = btn.textContent;
    btn.textContent = 'Un instant…';
    fetch(worker + '/inscrire', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prenom: prenom, pays: chPays.value, telephone: tel, site: chPiege.value, turnstile: jetonTurnstile() })
    }).then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (res) {
        if (res.d && res.d.ok) {
          var p = prenom.charAt(0).toUpperCase() + prenom.slice(1);
          sec.querySelector('[data-sms-ok-titre]').textContent = (res.d.deja ? 'Tu es déjà dans la liste, ' : "C'est noté, ") + p + ' ! 🔥';
          sec.classList.add('is-ok');
          if (window.dataLayer) window.dataLayer.push({ event: 'avent_2027_sms_inscription' });
        } else {
          montrerErreur(res.d && res.d.erreur);
        }
      })
      .catch(function () { montrerErreur('reseau'); })
      .then(function () { btn.disabled = false; btn.textContent = libelle; });
  }
  btn.addEventListener('click', envoyer);
  [chPrenom, chTel].forEach(function (ch) {
    ch.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); envoyer(); } });
  });
})();
